import { AnswerType, ExamStatus, ExamTypes } from "src/types/enums";

interface Question {
	answer: string | null;
	correctAnswer: string;
	isCanceled: boolean;
	answers: Record<string, string>;
}

interface GetTypesParams {
	examType: string;
	examStatus: string;
	question: Question;
	answer: string;
}

interface GetAnswerTypesByExamTypeParams {
	examType: string;
	examStatus: string;
	question: Question;
}

interface BasicAnswerTypesParams {
	examStatus: string;
	question: Question;
	answer: string;
}

const getTypes = ({
	examType,
	examStatus,
	question,
	answer,
}: GetTypesParams): string => {
	if ([ExamTypes.SIMULATION, ExamTypes.LEARNING].includes(examType)) {
		return getSimulationAnswerTypes({
			examStatus,
			question,
			answer,
		});
	}

	if ([ExamTypes.BASIC, ExamTypes.COURSE].includes(examType)) {
		return getBasicAnswerTypes({
			examStatus,
			question,
			answer,
		});
	}

	return getBasicAnswerTypes({
		examStatus,
		question,
		answer,
	});
};

export function getAnswerTypesByExamType({
	examType,
	examStatus,
	question,
}: GetAnswerTypesByExamTypeParams): Record<string, string> {
	return Object.keys(question.answers).reduce(
		(acc: Record<string, string>, answer) => {
			acc[answer] = getTypes({
				examType,
				examStatus,
				question,
				answer: answer.toUpperCase(),
			});

			return acc;
		},
		{},
	);
}

function getBasicAnswerTypes({
	examStatus,
	question,
	answer,
}: BasicAnswerTypesParams): string {
	if (!question.answer) {
		if (examStatus === ExamStatus.ACTIVE) {
			return "";
		}

		if (question.correctAnswer === answer) {
			return AnswerType.WARNING;
		}
		return "";
	}

	if (question.isCanceled) {
		return answer === question.answer ? AnswerType.WARNING : "";
	}

	if (question.correctAnswer === answer) {
		return AnswerType.CORRECT;
	}

	if (question.answer === answer) {
		return AnswerType.WRONG;
	}

	return "";
}

function getSimulationAnswerTypes({
	examStatus,
	question,
	answer,
}: BasicAnswerTypesParams): string {
	if (examStatus === ExamStatus.ACTIVE) {
		if (question.answer === answer) {
			return AnswerType.HIDDEN;
		}
		return "";
	}

	return getBasicAnswerTypes({
		examStatus,
		question,
		answer,
	});
}
